<div
  class="swipe-row"
  role="group"
  cdkMonitorElementFocus
  [attr.aria-label]="label()"
  [attr.tabindex]="isDisabled() ? null : 0"
  (cdkFocusChange)="$event === 'keyboard' && reveal()"
  (keydown.escape)="close()"
>
  <div
    class="swipe-row__content"
    awRowSwipe
    [dragLimit]="actionWidth()"
    [swipeDisabled]="isDisabled()"
    [longPressEnabled]="!isDisabled()"
    [rowActions]="tray"
    [slideActions]="true"
    (showActions)="opened.emit($event)"
    (longPressed)="showActionSheet()"
  >
    <ng-content />
  </div>
  <div #tray class="swipe-row__actions" [style.width.px]="actionWidth()">
    @if (!disabled()) {
      @for (item of rowActions(); track item.id) {
        @if (item.iconTemplate; as template) {
          <button
            class="swipe-row__custom"
            type="button"
            [attr.data-action]="item.id"
            [disabled]="item.disabled"
            [attr.aria-label]="item.label + ': ' + label()"
            [attr.title]="item.label"
            (click)="selectAction(item)"
          >
            <ng-container [ngTemplateOutlet]="template" />
          </button>
        } @else {
          <aw-icon-button
            [attr.title]="item.label"
            [attr.data-action]="item.id"
            [style]="'subtle'"
            [icon]="item.selectedTone === 'favorite' ? undefined : item.icon"
            [iconColorValue]="item.variant === 'destructive' ? 'var(--m-destructive-text)' : undefined"
            [selected]="item.selected || false"
            [selectedTone]="item.selectedTone"
            [pressed]="item.selected"
            [disabled]="item.disabled || false"
            [ariaLabel]="item.label + ': ' + label()"
            (click)="selectAction(item)"
          />
        }
      }
    }
  </div>
</div>
